/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Soft_Honest_Turkey_EngageInputs */

const fr_soft_honest_turkey_engage = /** @type {(inputs: Soft_Honest_Turkey_EngageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun paiement a afficher`)
};

/**

* @param {Soft_Honest_Turkey_EngageInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const soft_honest_turkey_engage = /** @type {((inputs?: Soft_Honest_Turkey_EngageInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Soft_Honest_Turkey_EngageInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_soft_honest_turkey_engage(inputs)
});